import { LayoutDashboard } from 'lucide-react'
import { EmptyState, PageHeader } from '@/components/ui'

export function VertraegeDashboardPage() {
  return (
    <div className="p-6 space-y-6">
      <PageHeader title="Vertrags-Dashboard" />
      <EmptyState
        icon={<LayoutDashboard />}
        title="Dashboard in Entwicklung"
        description="Das Vertrags-Dashboard wird in Kürze verfügbar sein."
      />
    </div>
  )
}
